<div class="custom-snackbar box-shadow-1">
    <div class="custom-snackbar__icon" class="{{ data.type }}">
        <img *ngIf="data.type === 'error'" src="assets/icons/close.svg" alt="Error Icon" />
        <img *ngIf="data.type === 'warning'" src="assets/icons/warning.svg" alt="Warning Icon" />
        <img *ngIf="data.type === 'information'" src="assets/icons/info.svg" alt="Info Icon" />
    </div>
    <div class="custom-snackbar__info">

        <p *ngIf="data.type === 'error'"><b>Error:</b></p>
        <p *ngIf="data.type === 'warning'"><b>Advertencia:</b></p>
        <p *ngIf="data.type === 'information'"><b>Información:</b></p>

        <p [innerHTML]="data.message"></p>
        <div (click)="snackBarRef.dismiss()">
            <img class="center" src="assets/icons/close-black.svg" alt="Close Icon" />
        </div>
    </div>
</div>